module.exports = __webpack_public_path__ + "29ee981798eb89929c84f1a3bd95149f.svg";